<ion-item class="Select" [id]="field.name" [formGroup]="group">
  <ion-label
    class="Select__Label"
    position="floating"
    [innerHTML]="field.label"
  ></ion-label>

  <ion-select
    interface="popover"
    [formControlName]="field.name || 'noName'"
    [multiple]="field.multiple"
    color="primary"
  >
    @for (item of getFieldOptions(field); track item) {
      <ion-select-option [value]="item">{{ item }}</ion-select-option>
    }
  </ion-select>
</ion-item>
